export default __webpack_public_path__ + "static/media/p2.c651b82d.jpg";